import {
  configCardanoLegacyTransfer,
  linksCardanoModuleMaker,
  linksYoroiModuleMaker,
} from '@yoroi/links'
import {Links} from '@yoroi/types'
import {PartnerInfoType} from 'common/partner-info'

export const requestAdaWithLink = ({
  scheme,
  address,
  amount,
  partnerInfo,
}: {
  scheme: Links.YoroiUriConfig['scheme']
  address: string
  amount: string
  partnerInfo: PartnerInfoType
}) => {
  try {
    const {transfer} = linksYoroiModuleMaker(scheme)
    const {create} = linksCardanoModuleMaker()

    const cardanoLink = create({
      config: configCardanoLegacyTransfer,
      params: {
        amount,
        address,
      },
    })

    const link = transfer.request.adaWithLink({
      link: cardanoLink.link,
      ...partnerInfo,
    })

    return {link, error: null}
  } catch (e: any) {
    return {error: e.message, link: null}
  }
}
